import commonVars from './common.module.scss';

export const colorPalette = Object.keys(commonVars)
    .filter((key) => key !== 'white')
    .map((key) => ({
        name: key,
        color: commonVars[key]
    }));